import { inject, provideAppInitializer } from '@angular/core';

import { OVERLAY_DEFAULT_CONFIG, OverlayContainer } from '@angular/cdk/overlay';
import { MatIconRegistry } from '@angular/material/icon';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

export const materialProviders = [
  { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },

  { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'never', appearance: 'outline' } },
  { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
  { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
  { provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: { color: 'primary' } },

  provideMomentDateAdapter(),

  provideAppInitializer(() => {
    const oc = inject(OverlayContainer);
    const registry = inject(MatIconRegistry);

    oc.getContainerElement().classList.add('zef-visual');

    registry.registerFontClassAlias('md', 'material-icons');
    registry.registerFontClassAlias('zeficons', 'zef-icons-full');
    registry.setDefaultFontSetClass('zef-icons-full');
    registry.registerFontClassAlias('zefplayer', 'zef-icons-free');
  }),
];
